import { render, staticRenderFns } from "./BrandActivity.vue?vue&type=template&id=0a3ccb0d&scoped=true"
import script from "./BrandActivity.vue?vue&type=script&lang=js"
export * from "./BrandActivity.vue?vue&type=script&lang=js"
import style0 from "./BrandActivity.vue?vue&type=style&index=0&id=0a3ccb0d&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a3ccb0d",
  null
  
)

export default component.exports